import { render } from "./FieldGroup_textarea.vue?vue&type=template&id=08c296fe"
import script from "./FieldGroup_textarea.vue?vue&type=script&lang=js"
export * from "./FieldGroup_textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__